<div class="flex justify-center">
  <div class="max-w-[1400px] w-full">
    <zaeper-page-layout [pageLayout]="ePageLayout.PLAIN">
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-10">
          <app-info-card [stretched]="true"
                            headline2="Willkommen zurück Dennis"
                            headline3="Developer Dashboard"
                            description="This is my description"
                            [splitBackground]="true"
                            backgroundImgSrc="https://i.pinimg.com/originals/46/92/cb/4692cb07c23af95bbd8de8886e2e0d09.png">
          </app-info-card>
        </div>
        <div class="col-span-2">
          <app-info-card [stretched]="true">
          </app-info-card>
        </div>

        <div class="col-span-2">
          <app-info-card [stretched]="true" headline2="Meine Apps" [splitBackground]="true" headline3="Apps"
                            link="/de/applications">
            <ng-template zTemplate="center">
              <div class="text-6xl">0</div>
            </ng-template>
          </app-info-card>
        </div>
        <div class="col-span-6">
          <app-info-card [stretched]="true" headline2="Lerne die Zaeper SDK kennen" headline3="Knowledge center"
                            description="Begebe dich in unser Knowledge Center und lerne unsere SDK kennen"
                            backgroundImgSrc="https://e0.pxfuel.com/wallpapers/477/267/desktop-wallpaper-panoramic-minimal-mountains-minimalist-and-background-panorama.jpg">
            <ng-template zTemplate="headerRight">
              <p-button severity="secondary" [rounded]="true">Knowledge center</p-button>
            </ng-template>
          </app-info-card>
        </div>
        <div class="col-span-2">
          <app-info-card [stretched]="true" headline2="Meine Launchers" headline3="Launchers">
            <ng-template zTemplate="center">
              <div class="text-6xl">0</div>
            </ng-template>
          </app-info-card>
        </div>
        <div class="col-span-2">
          <app-info-card [stretched]="true" headline2="Pakete, Registry & Tokens" [splitBackground]="true" headline3="Zaeper Registry"
                            link="/de/registry">
            <ng-template zTemplate="center">
              <i class="pi pi-box text-6xl"></i>
            </ng-template>
          </app-info-card>
        </div>
      </div>
    </zaeper-page-layout>
  </div>
</div>
